import * as Scrivito from "scrivito";

export default function configureObjClassForContentType() {
  Scrivito.configureObjClassForContentType({
    "image/*": "Image",
    "video/*": "Video",
    "*/*": "Download",
  });
}
